/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCommunicationPreferenceRequest
 */
export interface UpdateCommunicationPreferenceRequest {
    /**
     * The type of communication preference to update
     * @type {string}
     * @memberof UpdateCommunicationPreferenceRequest
     */
    type: UpdateCommunicationPreferenceRequestTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateCommunicationPreferenceRequest
     */
    enabled: boolean;
}


/**
 * @export
 */
export const UpdateCommunicationPreferenceRequestTypeEnum = {
    SmsChat: 'smsChat',
    GoogleEmailContactsExtraction: 'googleEmailContactsExtraction',
    OnboardingFlow: 'onboardingFlow'
} as const;
export type UpdateCommunicationPreferenceRequestTypeEnum = typeof UpdateCommunicationPreferenceRequestTypeEnum[keyof typeof UpdateCommunicationPreferenceRequestTypeEnum];


/**
 * Check if a given object implements the UpdateCommunicationPreferenceRequest interface.
 */
export function instanceOfUpdateCommunicationPreferenceRequest(value: object): value is UpdateCommunicationPreferenceRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function UpdateCommunicationPreferenceRequestFromJSON(json: any): UpdateCommunicationPreferenceRequest {
    return UpdateCommunicationPreferenceRequestFromJSONTyped(json, false);
}

export function UpdateCommunicationPreferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCommunicationPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'enabled': json['enabled'],
    };
}

export function UpdateCommunicationPreferenceRequestToJSON(json: any): UpdateCommunicationPreferenceRequest {
    return UpdateCommunicationPreferenceRequestToJSONTyped(json, false);
}

export function UpdateCommunicationPreferenceRequestToJSONTyped(value?: UpdateCommunicationPreferenceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'enabled': value['enabled'],
    };
}

